import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { authStore, type SoftwareCode } from '@/context/auth'

// Gates the whole Shakthi Power application behind SHAKTHI_POWER software
// access, granted per-employee from Employee Master's Software Access tab.
// ProtectedRoute already checks "is logged in" — this adds "is this login
// actually allowed into Shakthi Power" (a Grand-Shakthi-Power-only account
// can authenticate here since both apps share one login, but shouldn't reach
// any Shakthi Power screen by URL). Sends anyone without access back to
// /select-software, which shows only what they're actually allowed to open.
const RequireSoftwareAccess: React.FC<{ code: SoftwareCode }> = ({ code }) => {
  if (authStore.hasSoftwareAccess(code)) return <Outlet />
  return <Navigate to="/select-software" replace />
}

export default RequireSoftwareAccess
